<template>
    <div class="d-flex align-center">
        <v-autocomplete
            @input="isPassed = null"
            v-model="selectedPeriods"
            :items="periods"
            label="Periode"
            auto-select-first
            multiple
            small-chips
            clearable
            deletable-chips
            :loading="periodLoading"
        ></v-autocomplete>

        <v-btn
            @click="check"
            color="primary"
            small
            class="ml-4"
            :disabled="selectedPeriods.length == 0"
            :loading="similiarityLoading"
        >
            <v-icon left>mdi-cloud-check</v-icon>
            cek periode
        </v-btn>

        <similarity-alert :is-passed="isPassed" />
    </div>
</template>

<script>
import SimilarityAlert from './SimilarityAlert.vue'

export default {
    props: {
        tryouts: {
            type: Array,
            required: true
        }
    },

    components: {
        SimilarityAlert
    },

    data: () => ({
        periodLoading: false,
        similiarityLoading: false,
        selectedPeriods: [],
        periods: [],
        isPassed: null
    }),

    methods: {
        async check() {
            this.similiarityLoading = true

            const result = {}
            let isSimilarityExists = false
            for (const tryoutIdx in this.tryouts) {
                const tryout = this.tryouts[tryoutIdx]
                const questionIds = tryout.questions.map(
                    question => question.id
                )

                const periodIds = this.selectedPeriods.includes(0)
                    ? this.periods.map(period => period.value)
                    : this.selectedPeriods
                const response = await this.$apiv2.get(
                    'question-import/similiarity-check',
                    {
                        params: {
                            questionIds: questionIds,
                            periodIds
                        }
                    }
                )
                const similiarities = response.data.questions

                for (const questionIdx in tryout.questions) {
                    const question = tryout.questions[questionIdx]
                    const similiarity = similiarities[question.id]

                    if (similiarity === undefined) {
                        continue
                    }

                    if (result[tryoutIdx] === undefined) {
                        result[tryoutIdx] = {}
                    }

                    isSimilarityExists = true
                    result[tryoutIdx][questionIdx] = similiarity
                }
            }

            this.$emit('input', result)
            this.isPassed = !isSimilarityExists
            this.similiarityLoading = false
        }
    },

    async created() {
        this.periodLoading = true

        const response = await this.$api.get('period')
        this.periods = response.data.periods.map(period => ({
            text: period.title,
            value: period.id
        }))
        this.periods.push({ text: 'Semua', value: 0 })
        this.periods.reverse()

        this.periodLoading = false
    }
}
</script>
